module.exports = __webpack_public_path__ + "static/media/Statua_035.9cbc1c1b.jpg";